import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-371d43be"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "row" };
const _hoisted_2 = ["data-idx", "readonly", "id", "placeholder", "disabled", "value", "delayBetweenChangesDetected"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", {
            class: _normalizeClass('container-fluid ' + _ctx.cls),
            style: _normalizeStyle(_ctx.styl)
        }, [
            _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.axesIdxs, (axisIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass('col px-0' + (axisIdx === 1 ? ' px-1' : '')),
                        key: axisIdx
                    }, [
                        _createElementVNode("input", {
                            ref_for: true,
                            ref: `inputElem${_ctx.axes[axisIdx]}`,
                            "data-idx": axisIdx,
                            type: "number",
                            class: "form-control form-control-sm",
                            readonly: _ctx.readonly,
                            id: `${_ctx.axes[axisIdx]}-${_ctx.id}`,
                            placeholder: _ctx.axes[axisIdx].toUpperCase() + ' value...',
                            disabled: _ctx.disabled,
                            onInput: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onKeydown: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
                            value: _ctx.modelValue[axisIdx],
                            delayBetweenChangesDetected: _ctx.delayBetweenChangesDetected
                        }, null, 40, _hoisted_2)
                    ], 2));
                }), 128))
            ])
        ], 6),
        _createVNode(_component_FormElementDescription, {
            description: _ctx.description,
            warning: _ctx.warning
        }, null, 8, ["description", "warning"])
    ]));
}
